/* PURE advertorial: mobile sticky CTA.
   Shows once the first offer panel has scrolled above the viewport; hides again while any offer
   panel is on screen (so it never duplicates the button the reader is looking at). */
(function () {
  function init(root) {
    var bar = root.querySelector('[data-pv-adv-sticky]');
    var offers = root.querySelectorAll('[data-pv-offer]');
    if (!bar || !offers.length) return;
    var link = bar.querySelector('a');
    var first = offers[0];
    var visible = false;
    var ticking = false;

    function setVisible(next) {
      if (next === visible) return;
      visible = next;
      bar.classList.toggle('is-visible', next);
      bar.setAttribute('aria-hidden', next ? 'false' : 'true');
      if (link) link.setAttribute('tabindex', next ? '0' : '-1');
    }

    function update() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var passedFirst = first.getBoundingClientRect().bottom < 0;
      var offerOnScreen = false;
      for (var i = 0; i < offers.length; i++) {
        var r = offers[i].getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) {
          offerOnScreen = true;
          break;
        }
      }
      setVisible(passedFirst && !offerOnScreen);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-pv-adv]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pv-adv]');
    if (root) init(root);
  });
})();
